import React from "react"
import styled from "styled-components"
import { Link } from "gatsby"

import blob from "../assets/images/blob-shape.svg"

const StyledContact = styled.section`
  position: relative;
  overflow: hidden;
  background-color: ${({ theme }) => theme.colors.blue};
  color: #fff;
  padding: 4rem 0;
  .container {
    position: relative;
    z-index: 1;
  }
  .blob {
    position: absolute;
    transform: scale(1);
    z-index: 0;
    fill: #366df8;
    top: 0;
    bottom: 0;
    margin: auto;
  }
  .blob-1 {
    left: -400px;
    opacity: 0.2;
  }
  .blob-2 {
    right: -500px;
    opacity: 0.3;
  }
  @media only screen and (min-width: 600px) {
    .blob-1 {
      left: -300px;
    }
    .blob-2 {
      right: -400px;
    }
  }
  @media only screen and (min-width: 1000px) {
    .blob {
      transform: scale(2);
    }
  }
`

const ContactBanner = ({ heading, buttonText, buttonLink }) => (
  <StyledContact>
    <img className="blob blob-1" src={blob} alt="Blob" />
    <img className="blob blob-2" src={blob} alt="Blob" />
    <div className="container text-center">
      <h3 className="light">
        {heading ? heading : "Ready to try Dealer 9000?"}
      </h3>
      <Link
        to={buttonLink ? buttonLink : `/get-started`}
        className="btn btn-secondary"
      >
        {buttonText ? buttonText : "Get started"}
      </Link>
    </div>
  </StyledContact>
)

export default ContactBanner
